import * as React from 'react';
import { Box, Typography } from '@mui/material';
import QRCode from 'react-qr-code';
import MfaEntry from '../mfa-entry';
import { MfaMode } from '../../data/enums';

interface MfaProps {
  mode: MfaMode;
  qrCodeValue?: string | null;
  onCodeEntered: (code: string) => void;
}

export default function Mfa(props: MfaProps) { 

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '400px' }}>

      {/* Mode: ScanQrCode - Display QR code and six digit code entry */}
      { props.mode === MfaMode.ScanQrCode && props.qrCodeValue !== null &&        
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 'auto' }}>          
          <Typography variant="h5" component="h2" sx={{ mb: 2 }}>
            Configure Multi-Factor Authentication
          </Typography>          
          <Typography variant="body1" component="p" sx={{ fontSize: '.8rem'}}>
            To enable Multi-Factor Authentication, please scan the QR code below with your authenticator app. After scanning, the app will provide a verification code. Enter this code in the field below to complete the setup.
          </Typography>
          <Box sx={{ my: 4}}>
            <QRCode
              size={128}
              level='H'
              style={{ height: "auto", width: "auto", }}
              value={(props.qrCodeValue?props.qrCodeValue:'') }
              viewBox={`0 0 128 128`}/>
          </Box>
          <MfaEntry onCodeEntered={props.onCodeEntered} />
        </Box>
      }

      {/* Mode: Authenticate - Display six digit code entry */}
      { props.mode === MfaMode.Authenticate &&        
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 'auto' }}>          
          <Typography variant="h5" component="h2" sx={{ mb: 2 }}>
            Authenticate
          </Typography>          
          <Typography variant="body1" component="p" sx={{ mb: 2 }}>
            Enter six-digit code from your authenticator app to complete the sign-in process.
          </Typography>
          <MfaEntry onCodeEntered={props.onCodeEntered} />
        </Box>
      }

    </Box>
  );
}